<template>
  <div
    class="pl-3 pr-1 text-sm font-medium uppercase rounded-lg w-fit gap-x-2 flex-items-center"
    :class="`${style}`"
  >
    <p>{{ translateText(translationLabel) }}</p>
    <p class="bg-[#FFFFFF33] py-2 rounded-lg px-2 my-1">
      {{ value }}
    </p>
  </div>
</template>

<script>
import { translateText } from "@/core/helpers/utility";

export default {
  name: "SummaryCard",
  props: {
    translationLabel: {
      type: String,
      default: "",
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
    style: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      translateText,
    };
  },
};
</script>
